import client, { FetchConfig } from '@/services/network/http'

class userBaseApi {
  async post<T>(url: string, data?: object | string, options?: FetchConfig) {
    return client.post<T>('/uic' + url, { data }, options)
  }
  async get<T>(url: string, data?: object) {
    const options = {
      methods: 'GET',
      url: `/uic${url}`,
      data: { bizContent: data },
    }
    return client.fetch<T>(options)
  }
}

export default userBaseApi
